import React from "react";
import "./Skeleton.css"

const DetailsSkeleton = ({isRetailer}) => {

  return (
    <div className="app_main">
        {/* <div className="header_skeleton">
            <div className="load_skeleton avatar"></div>
            <div className="head info"></div>
        </div> */}
        <div className="header_skeleton row">
            <div className="col-md-7 info_round_row">
                <div className="detailsBox info_round"></div>
            </div>
            <div className="col-md-5">
                <div className="detailsBox info"></div>
            </div>
        </div>
        {isRetailer ? <>
            <div className="header_skeleton row mt-5">
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
            </div>
            <div className="header_skeleton row">
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
                <div className="col-md-4">
                    <div className="rentBox info"></div>
                </div>
            </div>
        </> : <div className="main_skeleton mt-2">
            <div className="inner_skeleton_details">
                <div className="items_skeleton">
                    <div className="load_skeleton_details item"></div>
                    <div className="load_skeleton_details item"></div>
                    <div className="load_skeleton_details item"></div>
                </div>
            </div>
        </div>}
    </div>
  )
}

export default DetailsSkeleton
